import axios from '../axios';
import { toQuery } from '@/plugins/toQuery';

export const getSpecifications = async (query = { page: 1 }) => {
  try {
    const res = await axios.get(`/specifications?${toQuery(query)}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};